import { t } from "@redotech/redo-i18n";
import { PriceOption } from "@redotech/redo-return-core-common/condition-options";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import {
  compareAtPriceFromModel,
  validateCompareAtPriceCondition,
  type CompareAtPriceState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const COMPARE_AT_PRICE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CompareAtPriceState>>,
): ConditionType<CompareAtPriceState, Condition.CompareAtPrice> => ({
  get name() {
    return t("Compare-at price");
  },
  description(state) {
    if (!state.priceOption) {
      return t(
        "The item's price compared to a percentage of its compare-at price",
      );
    }
    switch (state.priceOption) {
      case PriceOption.LESS_THAN:
        return t("Item price is less than {{value}}% of its compare-at price", {
          value: state.percentage,
        });
      case PriceOption.GREATER_THAN:
        return t(
          "Item price is greater than {{value}}% of its compare-at price",
          { value: state.percentage },
        );
      case PriceOption.EQUALS:
        return t("Item price equals {{value}}% of its compare-at price", {
          value: state.percentage,
        });
      case PriceOption.CENTS_EQUALS:
        return t("Item price cents equal {{value}}% of its compare-at price", {
          value: state.percentage,
        });
    }
  },
  Details(props: ConditionTypeDetailsProps<CompareAtPriceState>) {
    return React.createElement(Details, props);
  },
  empty: { percentage: "", priceOption: null },
  fromModel(model) {
    return compareAtPriceFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.COMPARE_AT_PRICE,
      percentage: +state.percentage,
      priceOption: state.priceOption,
    };
  },
  valid(state) {
    return validateCompareAtPriceCondition(state).valid;
  },
});
